import { IncomingMessage } from "http";
import { buildExpressRequestPagesRouter } from "./express-request";
import { getCountry } from "./get-country";
import { getKeyStoreDataversion } from "./get-key-store-dataversion";
import { getStorePresentationInstance } from "./store-presentation-provider";

export type GetStoreUrlOptions = {
  type?: "default" | "men" | "women" | "secure" | "my-account";
  includeProtocol?: boolean;
  req: IncomingMessage;
};

export const getStoreUrl = async ({
  type = "default",
  includeProtocol = true,
  req,
}: GetStoreUrlOptions) => {
  const store = getStorePresentationInstance();
  const [country, keyStoreDataversion] = await Promise.all([
    getCountry(req),
    getKeyStoreDataversion(req),
  ]);
  const { request } = await buildExpressRequestPagesRouter(req);

  if (type !== "my-account") {
    return store.getStoreUrlByCountryCode({
      countryCode: country.countryCode,
      includeProtocol,
      keyStoreDataversion,
      type,
      request,
      response: {},
    });
  }

  // Handle my-account type separately
  // Get the default store URL and then modify it to point to the my-account subdomain
  const url = await store.getStoreUrlByCountryCode({
    countryCode: country.countryCode,
    // Default to true for my-account to ensure the protocol is included
    // so we can construct the URL correctly
    includeProtocol: true,
    keyStoreDataversion,
    type: "default",
    request,
    response: {},
  });

  // The default url will be something like "https://www.asoschameleon.com/gb"
  // we need to change this to be "https://my.asoschameleon.com/my-account"
  const myAccountUrl = new URL(url);
  const hostParts = myAccountUrl.hostname.split(".");
  if (hostParts.length > 2) {
    hostParts[0] = "my";
    myAccountUrl.hostname = hostParts.join(".");
  } else {
    myAccountUrl.hostname = `my.${myAccountUrl.hostname}`;
  }
  myAccountUrl.pathname = "/my-account";

  return includeProtocol
    ? myAccountUrl.toString()
    : myAccountUrl.href.replace(/^https?:\/\//, "");
};
